export const getOperationTypeTitle = (operationType) => operationType.split("_").map(s=>{return s.charAt(0).toUpperCase() + s.slice(1);}).join(" ");



// WEBPACK FOOTER //
// ./src/formats.js